import CustomIcon from '@/common/components/base/customIcon/CustomIcon';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import CardSquare from '@/common/components/cardSquare/CardSquare';
import Costs from '@/modules/adjusterReportModules/IncidentParticipants/assets/iconComponents/Costs';
import SubstitutionParts from '@/modules/adjusterReportModules/IncidentParticipants/assets/iconComponents/SubstitutionParts';
import VisitInformation from '@/modules/adjusterReportModules/IncidentParticipants/assets/iconComponents/visitInformation';
import Wages from '@/modules/adjusterReportModules/IncidentParticipants/assets/iconComponents/Wages';
import { ExpertEntryTabsQueryResponseType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getExpertTabs/getExpertTabsQuery.type';
import { ADJUSTER_REPORT_BODY_DAMAGE_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/bodyDamage/bodyDamageLinks';
import { getBodyExpertTabsQueryOption } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyExpertTabs/getBodyExpertTabsQueryOption';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Grid } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

const BodyExpertEntryTabs = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, isPending } = useQuery(
    getBodyExpertTabsQueryOption({
      id: +id!,
      source: 'pwa',
    }),
  );

  const handleNavigateClick = (item: ExpertEntryTabsQueryResponseType) => {
    const EXPERT = ADJUSTER_REPORT_BODY_DAMAGE_LINKS.BODY_DAMAGE_INFORMATION({
      id: id!,
    }).EXPERT;
    let path = '';
    if (item?.name === 'visit_information') {
      path = item?.editable
        ? EXPERT.visitInformation
        : EXPERT.visitInformationShow;
    } else if (item?.name === 'costs') {
      path = item?.editable ? EXPERT.costs : EXPERT.costsShow;
    } else if (item?.name === 'substitution_parts') {
      path = item?.editable
        ? EXPERT.substitutionParts
        : EXPERT.substitutionPartsShow;
    } else if (item?.name === 'wages') {
      path = item?.editable ? EXPERT.wages : EXPERT.wagesShow;
    }
    return navigate(path);
  };

  return (
    <>
      {isPending ? (
        <Box
          mt="56px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <CircularLoading color="colors.purple-primary" />
        </Box>
      ) : (
        <Box mt="56px">
          <Grid
            className={css({
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '6px',
            })}
          >
            {data?.map((item) => (
              <Box key={item.name}>
                <CardSquare
                  disabled={item?.is_card_active}
                  title={item?.fa_name}
                  onClick={() => handleNavigateClick(item)}
                  renderIcon={() => {
                    switch (item.name) {
                      case 'visit_information':
                        return (
                          <CustomIcon
                            backgroundColor={
                              item?.is_card_active
                                ? token('colors.orange-3')
                                : token('colors.gray-3')
                            }
                            width="42px"
                            height="42px"
                          >
                            <VisitInformation
                              fill={
                                item?.is_card_active
                                  ? token('colors.orange-3')
                                  : token('colors.gray-3')
                              }
                              stroke={
                                item?.is_card_active
                                  ? token('colors.orange')
                                  : token('colors.gray')
                              }
                            />
                          </CustomIcon>
                        );
                      case 'wages':
                        return (
                          <Wages
                            fill={
                              item?.is_card_active
                                ? token('colors.purple-6')
                                : token('colors.gray-3')
                            }
                            stroke={
                              item?.is_card_active
                                ? token('colors.purple-primary')
                                : token('colors.gray')
                            }
                          />
                        );
                      case 'substitution_parts':
                        return (
                          <SubstitutionParts
                            fill={
                              item?.is_card_active
                                ? token('colors.green-4')
                                : token('colors.gray-3')
                            }
                            stroke={
                              item?.is_card_active
                                ? token('colors.green')
                                : token('colors.gray')
                            }
                          />
                        );
                      case 'costs':
                        return (
                          <Costs
                            fill={
                              item?.is_card_active
                                ? token('colors.purple-6')
                                : token('colors.gray-3')
                            }
                            stroke={
                              item?.is_card_active
                                ? token('colors.purple-primary')
                                : token('colors.gray')
                            }
                          />
                        );
                      default:
                        return null;
                    }
                  }}
                />
              </Box>
            ))}
          </Grid>
        </Box>
      )}
    </>
  );
};

export default BodyExpertEntryTabs;
